import axios from "axios";

const domain = window.location.hostname;
let baseDomain = domain.includes("localhost")
  ? "http://api.localhost:1244"
  : domain.includes("staging")
  ? "https://api-staging.tripac.net"
  : "https://api.tripac.net";
const baseUrl = `${baseDomain}/v4`;
const apiEndpoints = {
  dealers: {
    route: "/dealers",
    method: "get",
  },
  login: {
    route: "/login",
    method: "post",
  },
  products: {
    route: "/products",
    method: "get",
  },
  promptsExecute: {
    route: "/prompts/execute",
    method: "post",
  },
  rates: {
    route: "/rates",
    method: "get",
  },
  vinDecode: {
    route: "/vin-decode/:vin",
    method: "get",
  },
  contractAdd: {
    route: "/contracts/add",
    method: "post",
  },
};

const OnyxApi = async (endpoint, data, userToken = null) => {
  try {
    const { route, method } = apiEndpoints[endpoint];
    if (!route) {
      throw new Error(`Unknown endpoint: ${endpoint}`);
    }
    const config =
      userToken != null
        ? {
            usertoken: userToken,
          }
        : {};
    // Replace placeholders in the route with values from the data
    const replacedRoute = route.replace(/:(\w+)/g, (match, key) => {
      return data[key];
    });
    const url = `${baseUrl}${replacedRoute}`;

    let response;
    if (method === "get") {
      response = await axios[method](url, { headers: config, params: data });
    } else {
      response = await axios[method](url, data, { headers: config });
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};

export default OnyxApi;
